import React from "react";

interface CurrencyBadgeProps {
  currency?: string;
  rate?: number;
  inrAmount?: number; // INR value shown alongside; used to derive the original foreign amount
  perUnit?: boolean; // appends "/unit" to the derived foreign amount
  className?: string;
}

const symbolFor = (currency: string) =>
  currency === "USD" ? "$" : `${currency} `;

const CurrencyBadge: React.FC<CurrencyBadgeProps> = ({
  currency,
  rate,
  inrAmount,
  perUnit,
  className = "",
}) => {
  if (!currency || currency === "INR") return null;

  const sym = symbolFor(currency);

  const originalText =
    inrAmount != null && rate
      ? `${sym}${(inrAmount / rate).toFixed(2)}${perUnit ? "/unit" : ""}`
      : null;

  const rateText = rate ? `@ ₹${rate}/${currency}` : null;

  const text =
    [originalText, rateText].filter(Boolean).join(" · ") || `${currency} PO`;

  return (
    <span
      title={`Original ${currency} value — converted to INR @ ₹${rate}/${currency} at PO creation`}
      className={`block mt-0.5 text-[11px] font-medium text-amber-600 ${className} text-xs`}
    >
      {text}
    </span>
  );
};

export default CurrencyBadge;
